import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import config from "../../../config/config";

/**
 * Generated class for the LiberarDiasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-liberar-dias',
  templateUrl: 'liberar-dias.html',
})
export class LiberarDiasPage {
  usuario: any;
  grupo: any;
  servicos: any;
  local:any;
  horario:any
  servicoescolhido:any;
  localescolhido:any;
  horariosescolhidos:any = [];
  diasEscolhido:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public _http: Http,
    private alertCtrl: AlertController,
  ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.grupo = this.usuario.grupold;
    if (this.usuario.grupold == 2) {
      this.getServico()
    } else {
      this.getServicosOperador()
    }
    this.getLocal()

  }
  getServicosOperador() {
    this._http
    .get(config.urlAPI + "respectivo/servico/"+this.usuario.id, {})
    // .get(config.urlAPI + "respectivo/servico/15663", {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      this.servicos = res;
    })
    .catch(error => { });
  }
  getServico() {
    this._http
      .get(config.urlAPI + "pesquisar/servico", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.servicos = res;
      console.log(res)

      })
      .catch(error => { });
  }
  getLocal() {
    this._http
      .get(config.urlAPI + "pesquisar/local", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.local = res;
      })
      .catch(error => { });
  }
  async getHorarios(env) {

    this._http
      .post(config.urlAPI + "pesquisar/horario",env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.horario =res;
        res.map((r)=>{
          if (r.checked) {
            let id = r.id
            this.horariosescolhidos.push(id)
          }
        })
        return res;
      })
      .catch(error => { 
        return error
      });
  }
  adicionarhorario(env) {
    
    if (this.horariosescolhidos.indexOf(env) != -1) {
      this.horariosescolhidos.splice(this.horariosescolhidos.indexOf(env), 1)
    } else {
      this.horariosescolhidos.push(env)
    }
  }
  selcionados(env){
   
    if (this.localescolhido && this.diasEscolhido && this.servicoescolhido) {
      let buscar = {
        local:this.localescolhido,
        dia:this.diasEscolhido,
        servico:this.servicoescolhido,
      }
      this.horariosescolhidos = []
      let loading = this.loadingCtrl.create({
        content: "Aguarde"
      });
      loading.present();
      this.getHorarios(buscar).then((r)=>{
        loading.dismiss();
      })      
    } 
  }
  salvar(){
    if (this.diasEscolhido == undefined||this.diasEscolhido == null  || this.localescolhido == undefined||this.localescolhido == null  ||this.servicoescolhido == undefined||this.servicoescolhido == null) {
      let alert = this.alertCtrl.create({
        title: "Por favor",
        subTitle: `Preencha todos os dados`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              // this.ionViewDidLoad()
            }
          }
        ]
      });
      alert.present();
      return true
    }
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    let env={
      dia:this.diasEscolhido,
      horario:this.horariosescolhidos,
      servico:this.servicoescolhido,
      local:this.localescolhido
    }
    this.servicoescolhido=null;
    this.localescolhido=null;
    this.horariosescolhidos = [];
    this.diasEscolhido=null;
    this.horario = null;
    this.enviardados(env).then((r)=>{
      loading.dismiss()

    })
  }
  async enviardados(env){

    this._http
    .post(config.urlAPI + "cadastro/diaHrarioServico",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      console.log(res)
      if (res.success == false) {
        let alert = this.alertCtrl.create({
          title: "Error",
          subTitle: `Alteração não realizada devido o Horário ${res.item.inicio} Já está agendado`,
          buttons: [
            {
              text: "OK",
              handler: data => {
                // this.ionViewDidLoad()
              }
            }
          ]
        });
        alert.present();
      } else {
        let alert = this.alertCtrl.create({
          title: "Sucesso",
          subTitle: "Horários liberados para agendamento",
          buttons: [
            {
              text: "OK",
              handler: data => {
                // this.ionViewDidLoad()
              }
            }
          ]
        });
        alert.present();
      }
      return res;
    })
    .catch(error => { 
      console.log(error)

      return error
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/agenda/liberar-dias/liberar-dias.ts